import api from "./api";

const buildOptionFormData = (payload) => {
  const fd = new FormData();

  fd.append("productId", payload.productId ?? "");
  fd.append("optionType", payload.optionType ?? "");
  fd.append("value", payload.value ?? "");
  fd.append("extraPrice", payload.extraPrice ?? 0);
  fd.append("quantity", payload.quantity ?? 0);

  if (payload.image instanceof File) {
    fd.append("image", payload.image);
  }

  return fd;
};

export const UpdateProductOption = async (optionId, payload) => {
  console.log("update image:", payload.image);
console.log("is file:", payload.image instanceof File);
  const fd = buildOptionFormData(payload);

  return api
    .put(`ProductOptions/${optionId}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};

export const GetProductOptions = async (productId) => {
  return api.get(`Product/${productId}/options`).then((res) => res.data);
};

export const DeleteProductOption = async (optionId) => {
  return api.delete(`ProductOptions/${optionId}`).then((res) => res.data);
};

export const AddProductOption = async (payload) => {
  const fd = buildOptionFormData(payload);

  return api
    .post(`ProductOptions`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};